<div class="grid-renderer-editor">
  <div class="d-flex align-items-baseline mb-4">
    <h2 class="mb-0">{{_(KEYS.GRID_RENDERER.TITLE)}}</h2>
    <span class="badge badge-warning ml-3 unsaved-badge" *ngIf="hasUnsavedChanges">
      <i class="fa fa-exclamation-triangle"></i> {{_(KEYS.GRID_RENDERER.UNSAVED_CHANGES)}}
    </span>
  </div>

  <div class="alert alert-info mt-2 mb-0" style="width: 637px">
    <i class="fa fa-info-circle"></i>
    {{_(KEYS.GRID_RENDERER.HINT)}}
  </div>
  <br>

  <div class="layout-container d-flex mt-2">
    <!-- Available fields (left side) -->
    <div class="available-fields mr-4">
      <h6>{{_(KEYS.GRID_RENDERER.AVAILABLE_FIELDS)}}</h6>

      <!-- Search field -->
      <div class="field-search mb-2">
        <div class="input-group input-group-sm">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="fieldSearchTerm"
            [placeholder]="_(KEYS.GRID_RENDERER.SEARCH_FIELDS)"
          >
          <span class="input-group-btn" *ngIf="fieldSearchTerm">
            <button class="btn btn-secondary" type="button" (click)="fieldSearchTerm = ''">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </div>
      </div>

      <!-- Scrollable fields container -->
      <div class="available-fields-scroll">
        <!-- Standard fields section -->
        <div class="fields-section">
          <div class="fields-section-header">{{_(KEYS.GRID_RENDERER.STANDARD_FIELDS)}}</div>
          <div class="available-fields-list">
            <div
              *ngFor="let def of filteredStandardFields"
              class="available-field field-type-standard"
            >
              <span class="field-name">
                <i class="fa fa-arrows mr-2"></i>
                {{_(KEYS.CRUD[def.labelKey] || def.labelKey)}}
              </span>
              <span class="field-add-buttons">
                <button
                  class="btn btn-xs btn-outline-success"
                  (click)="addToDisplay(def.key, 'standard')"
                  title="{{_(KEYS.GRID_RENDERER.ADD_TO_DISPLAY)}}"
                >
                  <i class="fa fa-plus"></i> {{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_SHORT)}}
                </button>
                <button
                  class="btn btn-xs btn-outline-secondary"
                  (click)="addToDetail(def.key, 'standard')"
                  title="{{_(KEYS.GRID_RENDERER.ADD_TO_DETAIL)}}"
                >
                  <i class="fa fa-plus"></i> {{_(KEYS.GRID_RENDERER.DETAIL_LINE_SHORT)}}
                </button>
              </span>
            </div>
            <div *ngIf="availableStandardFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.GRID_RENDERER.ALL_STANDARD_PLACED)}}
            </div>
            <div *ngIf="availableStandardFields.length > 0 && filteredStandardFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.GRID_RENDERER.NO_SEARCH_RESULTS)}}
            </div>
          </div>
        </div>

        <!-- Custom fields section -->
        <div class="fields-section">
          <div class="fields-section-header">{{_(KEYS.GRID_RENDERER.CUSTOM_FIELDS)}}</div>
          <div class="available-fields-list">
            <div
              *ngFor="let def of filteredCustomFields"
              class="available-field field-type-custom"
            >
              <span class="field-name">
                <i class="fa fa-arrows mr-2"></i>
                {{def.label}}
              </span>
              <span class="field-add-buttons">
                <button
                  class="btn btn-xs btn-outline-success"
                  (click)="addToDisplay(def.key, 'custom')"
                  title="{{_(KEYS.GRID_RENDERER.ADD_TO_DISPLAY)}}"
                >
                  <i class="fa fa-plus"></i> {{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_SHORT)}}
                </button>
                <button
                  class="btn btn-xs btn-outline-secondary"
                  (click)="addToDetail(def.key, 'custom')"
                  title="{{_(KEYS.GRID_RENDERER.ADD_TO_DETAIL)}}"
                >
                  <i class="fa fa-plus"></i> {{_(KEYS.GRID_RENDERER.DETAIL_LINE_SHORT)}}
                </button>
              </span>
            </div>
            <div *ngIf="customDefinitions.length === 0" class="text-muted small mb-2">
              {{_(KEYS.GRID_RENDERER.NO_CUSTOM_FIELDS)}}
            </div>
            <div *ngIf="customDefinitions.length > 0 && availableCustomFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.GRID_RENDERER.ALL_CUSTOM_PLACED)}}
            </div>
            <div *ngIf="availableCustomFields.length > 0 && filteredCustomFields.length === 0" class="text-muted small mb-2">
              {{_(KEYS.GRID_RENDERER.NO_SEARCH_RESULTS)}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuration area (right side) -->
    <div class="config-area">
      <!-- Display field zone -->
      <div class="config-zone mb-4">
        <h6>
          <i class="fa fa-link mr-1"></i>
          {{_(KEYS.GRID_RENDERER.DISPLAY_FIELD)}}
        </h6>
        <p class="text-muted small zone-desc mt-2">{{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_DESC)}}</p>
        <div
          class="drop-zone display-zone"
          [dragula]="'grid-renderer-display'"
          [(dragulaModel)]="displayFields"
        >
          <div *ngFor="let entry of displayFields; let i = index" class="placed-field" [ngClass]="'field-type-' + entry.fieldType">
            <span class="drag-handle"><i class="fa fa-arrows"></i></span>
            <input
              type="text"
              class="form-control form-control-sm label-input"
              [placeholder]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
              [value]="entry.label || ''"
              (input)="onDisplayLabelChange(i, $event.target.value)"
            >
            <span class="badge badge-success placed-field-name">{{getFieldLabel(entry)}}</span>
            <button class="btn btn-sm btn-danger remove-btn" (click)="removeFromDisplay(i)">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div *ngIf="displayFields.length === 0" class="text-muted small drop-hint">
            {{_(KEYS.GRID_RENDERER.DROP_HINT)}}
          </div>
        </div>
      </div>

      <!-- Detail line zone -->
      <div class="config-zone mb-4">
        <h6>
          <i class="fa fa-info-circle mr-1"></i>
          {{_(KEYS.GRID_RENDERER.DETAIL_LINE)}}
        </h6>
        <p class="text-muted small zone-desc mt-2">{{_(KEYS.GRID_RENDERER.DETAIL_LINE_DESC)}}</p>
        <div
          class="drop-zone detail-zone"
          [dragula]="'grid-renderer-detail'"
          [(dragulaModel)]="detailFields"
        >
          <div *ngFor="let entry of detailFields; let i = index" class="placed-field" [ngClass]="'field-type-' + entry.fieldType">
            <span class="drag-handle"><i class="fa fa-arrows"></i></span>
            <input
              type="text"
              class="form-control form-control-sm label-input"
              [placeholder]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
              [value]="entry.label || ''"
              (input)="onDetailLabelChange(i, $event.target.value)"
            >
            <span class="badge badge-success placed-field-name">{{getFieldLabel(entry)}}</span>
            <button class="btn btn-sm btn-danger remove-btn" (click)="removeFromDetail(i)">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div *ngIf="detailFields.length === 0" class="text-muted small drop-hint">
            {{_(KEYS.GRID_RENDERER.DROP_HINT)}}
          </div>
        </div>
      </div>

      <!-- Preview -->
      <div class="config-zone">
        <h6>
          <i class="fa fa-eye mr-1"></i>
          {{_(KEYS.GRID_RENDERER.PREVIEW)}}
        </h6>
        <div class="preview-box">
          <div class="preview-display">
            <a class="badge badge-success preview-link">{{previewDisplayText}}</a>
          </div>
          <div class="preview-detail text-muted small" *ngIf="previewDetailText">
            {{previewDetailText}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fixed save footer -->
<div class="save-footer">
  <button class="btn btn-primary" (click)="onSave()" [disabled]="!hasUnsavedChanges || isSaving">
    <i class="fa fa-save"></i> {{_(KEYS.GRID_RENDERER.SAVE)}}
    <i class="fa fa-spinner fa-spin ml-1" *ngIf="isSaving"></i>
  </button>

  <div class="vl"></div>

  <button class="btn btn-success" (click)="onLoadDefault()">
    <i class="fa fa-magic"></i> {{_(KEYS.GRID_RENDERER.LOAD_DEFAULT)}}
  </button>

  <button class="btn btn-warning" (click)="onReset()" [disabled]="displayFields.length === 0 && detailFields.length === 0">
    <i class="fa fa-refresh"></i> {{_(KEYS.GRID_RENDERER.RESET)}}
  </button>
</div>
